export default {
  taxes: [],
  tax: undefined,
};
